export function DeleteIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.125 4.75C11.9592 4.75 11.8003 4.81585 11.6831 4.93306C11.5658 5.05027 11.5 5.20924 11.5 5.375V12.3694C11.4821 12.6854 11.34 12.9816 11.1047 13.1934C10.8694 13.4051 10.5599 13.5153 10.2437 13.5H5.25625C4.94006 13.5153 4.63061 13.4051 4.39532 13.1934C4.16002 12.9816 4.01793 12.6854 4 12.3694V5.375C4 5.20924 3.93415 5.05027 3.81694 4.93306C3.69973 4.81585 3.54076 4.75 3.375 4.75C3.20924 4.75 3.05027 4.81585 2.93306 4.93306C2.81585 5.05027 2.75 5.20924 2.75 5.375V12.3694C2.76784 13.017 3.04161 13.6312 3.51136 14.0774C3.98111 14.5236 4.60855 14.7655 5.25625 14.75H10.2437C10.8915 14.7655 11.5189 14.5236 11.9886 14.0774C12.4584 13.6312 12.7322 13.017 12.75 12.3694V5.375C12.75 5.20924 12.6842 5.05027 12.5669 4.93306C12.4497 4.81585 12.2908 4.75 12.125 4.75Z"
        fill="#F9F9F9"
      />
      <path
        d="M12.75 2.875H10.25V1.625C10.25 1.45924 10.1842 1.30027 10.0669 1.18306C9.94973 1.06585 9.79076 1 9.625 1H5.875C5.70924 1 5.55027 1.06585 5.43306 1.18306C5.31585 1.30027 5.25 1.45924 5.25 1.625V2.875H2.75C2.58424 2.875 2.42527 2.94085 2.30806 3.05806C2.19085 3.17527 2.125 3.33424 2.125 3.5C2.125 3.66576 2.19085 3.82473 2.30806 3.94194C2.42527 4.05915 2.58424 4.125 2.75 4.125H12.75C12.9158 4.125 13.0747 4.05915 13.1919 3.94194C13.3092 3.82473 13.375 3.66576 13.375 3.5C13.375 3.33424 13.3092 3.17527 13.1919 3.05806C13.0747 2.94085 12.9158 2.875 12.75 2.875ZM6.5 2.875V2.25H9V2.875H6.5Z"
        fill="#F9F9F9"
      />
      <path
        d="M7.125 11V6.625C7.125 6.45924 7.05915 6.30027 6.94194 6.18306C6.82473 6.06585 6.66576 6 6.5 6C6.33424 6 6.17527 6.06585 6.05806 6.18306C5.94085 6.30027 5.875 6.45924 5.875 6.625V11C5.875 11.1658 5.94085 11.3247 6.05806 11.4419C6.17527 11.5592 6.33424 11.625 6.5 11.625C6.66576 11.625 6.82473 11.5592 6.94194 11.4419C7.05915 11.3247 7.125 11.1658 7.125 11Z"
        fill="#F9F9F9"
      />
      <path
        d="M9.625 11V6.625C9.625 6.45924 9.55915 6.30027 9.44194 6.18306C9.32473 6.06585 9.16576 6 9 6C8.83424 6 8.67527 6.06585 8.55806 6.18306C8.44085 6.30027 8.375 6.45924 8.375 6.625V11C8.375 11.1658 8.44085 11.3247 8.55806 11.4419C8.67527 11.5592 8.83424 11.625 9 11.625C9.16576 11.625 9.32473 11.5592 9.44194 11.4419C9.55915 11.3247 9.625 11.1658 9.625 11Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function DeleteIconDark(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${props.dimension}`}
      height={`${props.dimension}`}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M9.5 3.5C9.36739 3.5 9.24021 3.55268 9.14645 3.64645C9.05268 3.74021 9 3.86739 9 4V9.5955C8.98566 9.84834 8.87199 10.0853 8.68375 10.2547C8.49551 10.4241 8.24795 10.5123 7.995 10.5H4.005C3.75205 10.5123 3.50449 10.4241 3.31625 10.2547C3.12801 10.0853 3.01434 9.84834 3 9.5955V4C3 3.86739 2.94732 3.74021 2.85355 3.64645C2.75979 3.55268 2.63261 3.5 2.5 3.5C2.36739 3.5 2.24021 3.55268 2.14645 3.64645C2.05268 3.74021 2 3.86739 2 4V9.5955C2.01427 10.1136 2.23329 10.605 2.60909 10.9619C2.98489 11.3189 3.48684 11.5124 4.005 11.5H7.995C8.51316 11.5124 9.01511 11.3189 9.39091 10.9619C9.76671 10.605 9.98573 10.1136 10 9.5955V4C10 3.86739 9.94732 3.74021 9.85355 3.64645C9.75979 3.55268 9.63261 3.5 9.5 3.5Z"
        fill="#515F7B"
      />
      <path
        d="M10 2H8V1C8 0.867392 7.94732 0.740215 7.85355 0.646447C7.75979 0.552678 7.63261 0.5 7.5 0.5H4.5C4.36739 0.5 4.24021 0.552678 4.14645 0.646447C4.05268 0.740215 4 0.867392 4 1V2H2C1.86739 2 1.74021 2.05268 1.64645 2.14645C1.55268 2.24021 1.5 2.36739 1.5 2.5C1.5 2.63261 1.55268 2.75979 1.64645 2.85355C1.74021 2.94732 1.86739 3 2 3H10C10.1326 3 10.2598 2.94732 10.3536 2.85355C10.4473 2.75979 10.5 2.63261 10.5 2.5C10.5 2.36739 10.4473 2.24021 10.3536 2.14645C10.2598 2.05268 10.1326 2 10 2ZM5 2V1.5H7V2H5Z"
        fill="#515F7B"
      />
      <path
        d="M5.5 8.5V5C5.5 4.86739 5.44732 4.74021 5.35355 4.64645C5.25979 4.55268 5.13261 4.5 5 4.5C4.86739 4.5 4.74021 4.55268 4.64645 4.64645C4.55268 4.74021 4.5 4.86739 4.5 5V8.5C4.5 8.63261 4.55268 8.75979 4.64645 8.85355C4.74021 8.94732 4.86739 9 5 9C5.13261 9 5.25979 8.94732 5.35355 8.85355C5.44732 8.75979 5.5 8.63261 5.5 8.5Z"
        fill="#515F7B"
      />
      <path
        d="M7.5 8.5V5C7.5 4.86739 7.44732 4.74021 7.35355 4.64645C7.25979 4.55268 7.13261 4.5 7 4.5C6.86739 4.5 6.74021 4.55268 6.64645 4.64645C6.55268 4.74021 6.5 4.86739 6.5 5V8.5C6.5 8.63261 6.55268 8.75979 6.64645 8.85355C6.74021 8.94732 6.86739 9 7 9C7.13261 9 7.25979 8.94732 7.35355 8.85355C7.44732 8.75979 7.5 8.63261 7.5 8.5Z"
        fill="#515F7B"
      />
    </svg>
  );
}
export function DropdownIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
    >
      <path
        d="M14 1.30003C14 1.15362 13.9378 1.00802 13.8148 0.879213C13.7031 0.76335 13.5473 0.667726 13.3622 0.601374C13.1771 0.535023 12.9688 0.500133 12.7569 0.500001L1.24285 0.5C0.811503 0.5 0.411234 0.644004 0.184995 0.879212C0.0740643 0.995331 0.0108431 1.1277 0.00127509 1.26387C-0.00829292 1.40004 0.0361067 1.53555 0.1303 1.65764L5.88734 8.05783C5.99076 8.19072 6.14961 8.30246 6.34609 8.38055C6.54258 8.45864 6.76896 8.5 6.99989 8.5C7.23082 8.5 7.4572 8.45864 7.65368 8.38055C7.85017 8.30246 8.00901 8.19072 8.11244 8.05783L13.8695 1.65764C13.9565 1.54563 14 1.42163 14 1.30003Z"
        fill="#161E2E"
      />
    </svg>
  );
}
export function CloseEyeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
      />
    </svg>
  );
}
export function OpenEyeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
}
export function ReplaceIcon(props) {
  return (
    <svg
      className={props.classes}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2734_4913)">
        <path d="M3.73645 0.994949C3.57408 0.999788 3.41996 1.06767 3.30676 1.18418L0.806764 3.68422C0.690345 3.80133 0.625 3.95977 0.625 4.1249C0.625 4.29003 0.690345 4.44846 0.806764 4.56558L3.30676 7.06677C3.42436 7.18394 3.58364 7.24967 3.74964 7.24951C3.91564 7.24936 4.0748 7.18336 4.19218 7.06598C4.30956 6.9486 4.37557 6.78942 4.37572 6.62342C4.37587 6.45742 4.31015 6.29811 4.19299 6.18051L2.76355 4.75113H12.5023V6.66516C12.4946 6.75161 12.5049 6.83877 12.5326 6.92101C12.5604 7.00325 12.605 7.07876 12.6635 7.14282C12.7221 7.20689 12.7934 7.25805 12.8728 7.29306C12.9522 7.32806 13.0381 7.34619 13.1249 7.34619C13.2117 7.34619 13.2975 7.32806 13.3769 7.29306C13.4564 7.25805 13.5276 7.20689 13.5862 7.14282C13.6448 7.07876 13.6894 7.00325 13.7171 6.92101C13.7449 6.83877 13.7552 6.75161 13.7474 6.66516V4.75113C13.7474 4.06945 13.184 3.49989 12.5023 3.49989H2.75744L4.19299 2.06554C4.28259 1.97746 4.34357 1.86447 4.36797 1.74121C4.39237 1.61796 4.37906 1.49022 4.32977 1.37464C4.28048 1.25906 4.19751 1.16099 4.09167 1.09328C3.98583 1.02556 3.86204 0.991259 3.73645 0.994949ZM11.2426 8.49254C11.1182 8.49281 10.9967 8.53019 10.8937 8.59988C10.7907 8.66957 10.7108 8.76842 10.6642 8.88377C10.6177 8.99911 10.6066 9.12571 10.6325 9.24738C10.6583 9.36905 10.7198 9.48024 10.8092 9.56674L12.2435 11.0023H2.49988V9.14314C2.50085 9.05983 2.48516 8.97722 2.45373 8.90006C2.4223 8.8229 2.37576 8.7528 2.31685 8.69388C2.25794 8.63497 2.18784 8.58842 2.11068 8.55699C2.03352 8.52556 1.95086 8.50988 1.86755 8.51085C1.70179 8.5128 1.54359 8.58049 1.42776 8.69908C1.31192 8.81766 1.24794 8.97738 1.24988 9.14314V11.0023C1.24988 11.684 1.81819 12.2474 2.49988 12.2474H12.2435L10.8092 13.6829C10.747 13.7399 10.697 13.8088 10.6621 13.8855C10.6273 13.9623 10.6083 14.0453 10.6063 14.1296C10.6044 14.2139 10.6195 14.2976 10.6508 14.3759C10.6821 14.4542 10.7288 14.5254 10.7883 14.5851C10.8478 14.6449 10.9188 14.6919 10.9969 14.7235C11.0751 14.7551 11.1588 14.7705 11.2431 14.769C11.3274 14.7674 11.4105 14.7488 11.4874 14.7142C11.5643 14.6797 11.6334 14.6299 11.6906 14.568L14.1906 12.0679C14.2489 12.0098 14.2953 11.9408 14.3269 11.8648C14.3585 11.7887 14.3747 11.7072 14.3747 11.6249C14.3747 11.5425 14.3585 11.461 14.3269 11.385C14.2953 11.3089 14.2489 11.2398 14.1906 11.1817L11.6906 8.68177C11.6323 8.6219 11.5627 8.57428 11.4857 8.54178C11.4088 8.50928 11.3261 8.49255 11.2426 8.49254Z" />
      </g>
      <defs>
        <clipPath id="clip0_2734_4913">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ReplaceIconWhite(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M4.4821 0.326191C4.2656 0.332643 4.06011 0.423155 3.90918 0.578502L0.575848 3.91189C0.420623 4.06804 0.333496 4.27928 0.333496 4.49946C0.333496 4.71964 0.420623 4.93088 0.575848 5.08703L3.90918 8.42195C4.06597 8.57817 4.27835 8.66582 4.49968 8.66561C4.72102 8.66541 4.93323 8.5774 5.08974 8.4209C5.24624 8.26439 5.33426 8.05216 5.33446 7.83082C5.33466 7.60949 5.24704 7.39707 5.09081 7.24027L3.1849 5.33444H16.1699V7.88648C16.1596 8.00174 16.1733 8.11795 16.2103 8.2276C16.2474 8.33725 16.3068 8.43794 16.3849 8.52336C16.463 8.60877 16.558 8.677 16.6639 8.72367C16.7698 8.77034 16.8843 8.79451 17 8.79451C17.1157 8.79451 17.2302 8.77034 17.3361 8.72367C17.442 8.677 17.537 8.60877 17.6151 8.52336C17.6932 8.43794 17.7526 8.33725 17.7896 8.2276C17.8267 8.11795 17.8404 8.00174 17.8301 7.88648V5.33444C17.8301 4.42553 17.0788 3.66611 16.1699 3.66611H3.17676L5.09081 1.75365C5.21029 1.6362 5.29159 1.48555 5.32412 1.32121C5.35666 1.15687 5.33891 0.986548 5.27319 0.832447C5.20747 0.678346 5.09684 0.547582 4.95572 0.457297C4.81461 0.367011 4.64955 0.321272 4.4821 0.326191ZM14.4902 10.323C14.3244 10.3233 14.1624 10.3732 14.0251 10.4661C13.8877 10.559 13.7812 10.6908 13.7191 10.8446C13.6571 10.9984 13.6423 11.1672 13.6768 11.3294C13.7112 11.4917 13.7933 11.6399 13.9124 11.7552L15.8249 13.6693H2.83333V11.1904C2.83463 11.0794 2.81371 10.9692 2.7718 10.8663C2.72989 10.7635 2.66784 10.67 2.58929 10.5914C2.51074 10.5129 2.41728 10.4508 2.31441 10.4089C2.21153 10.367 2.10131 10.3461 1.99023 10.3474C1.76922 10.35 1.55829 10.4402 1.40384 10.5984C1.24939 10.7565 1.16408 10.9694 1.16666 11.1904V13.6693C1.16666 14.5783 1.92441 15.3295 2.83333 15.3295H15.8249L13.9124 17.2435C13.8295 17.3194 13.7628 17.4113 13.7163 17.5136C13.6699 17.6159 13.6446 17.7267 13.642 17.8391C13.6394 17.9514 13.6595 18.0631 13.7012 18.1675C13.7429 18.2719 13.8053 18.3668 13.8846 18.4464C13.9639 18.5261 14.0585 18.5888 14.1627 18.631C14.2669 18.6731 14.3786 18.6937 14.491 18.6915C14.6033 18.6894 14.7141 18.6646 14.8166 18.6186C14.9192 18.5725 15.0113 18.5061 15.0876 18.4235L18.4209 15.0902C18.4987 15.0127 18.5605 14.9207 18.6026 14.8193C18.6448 14.7179 18.6665 14.6092 18.6665 14.4994C18.6665 14.3896 18.6448 14.2809 18.6026 14.1795C18.5605 14.0781 18.4987 13.986 18.4209 13.9086L15.0876 10.5753C15.0099 10.4955 14.917 10.432 14.8144 10.3886C14.7118 10.3453 14.6016 10.323 14.4902 10.323Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function AnswerIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M22.25 19.375C22.9393 19.375 23.5 18.8143 23.5 18.125V5.75C23.5 5.06072 22.9393 4.5 22.25 4.5H5.75C5.06072 4.5 4.5 5.06072 4.5 5.75V18.125C4.5 18.8143 5.06072 19.375 5.75 19.375H14C14.4493 19.375 14.8125 19.739 14.8125 20.1875V22.3511L17.5503 19.6133L22.25 19.375ZM22.25 19.375H18.125M22.25 19.375H18.125M18.125 19.375C17.9092 19.375 17.7027 19.4602 17.5505 19.613L18.125 19.375ZM5.75 21H13.1875V24.3125C13.1875 24.6407 13.3849 24.9373 13.6888 25.0632L13.6891 25.0634C13.7896 25.1047 13.8951 25.125 14 25.125C14.2113 25.125 14.4193 25.0421 14.5745 24.887L18.4614 21H22.25C23.8357 21 25.125 19.7107 25.125 18.125V5.75C25.125 4.16434 23.8357 2.875 22.25 2.875H5.75C4.16434 2.875 2.875 4.16434 2.875 5.75V18.125C2.875 19.7107 4.16434 21 5.75 21Z"
        fill="#515F7B"
        stroke="#515F7B"
        strokeWidth="0.25"
      />
      <path
        d="M14.6245 7.5259C14.5117 7.28253 14.2684 7.12646 14.0002 7.12646C13.7321 7.12646 13.4887 7.28253 13.376 7.5259L9.25098 16.4634L10.4995 17.0395L11.9027 14.0001H16.0985L17.501 17.0395L18.7495 16.4634L14.6245 7.5259ZM12.5372 12.6251L14.0002 9.45434L15.4632 12.6251H12.5372Z"
        fill="#515F7B"
      />
    </svg>
  );
}
export function DragIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="25"
      viewBox="0 0 16 25"
      fill="none"
    >
      <path
        d="M5.33333 4.00016C6.06971 4.00016 6.66667 3.40321 6.66667 2.66683C6.66667 1.93045 6.06971 1.3335 5.33333 1.3335C4.59695 1.3335 4 1.93045 4 2.66683C4 3.40321 4.59695 4.00016 5.33333 4.00016Z"
        fill="#515F7B"
      />
      <path
        d="M5.33333 10.1667C6.06971 10.1667 6.66667 9.56971 6.66667 8.83333C6.66667 8.09695 6.06971 7.5 5.33333 7.5C4.59695 7.5 4 8.09695 4 8.83333C4 9.56971 4.59695 10.1667 5.33333 10.1667Z"
        fill="#515F7B"
      />
      <path
        d="M5.33333 16.3332C6.06971 16.3332 6.66667 15.7362 6.66667 14.9998C6.66667 14.2635 6.06971 13.6665 5.33333 13.6665C4.59695 13.6665 4 14.2635 4 14.9998C4 15.7362 4.59695 16.3332 5.33333 16.3332Z"
        fill="#515F7B"
      />
      <path
        d="M11 4.00016C11.7364 4.00016 12.3333 3.40321 12.3333 2.66683C12.3333 1.93045 11.7364 1.3335 11 1.3335C10.2636 1.3335 9.66666 1.93045 9.66666 2.66683C9.66666 3.40321 10.2636 4.00016 11 4.00016Z"
        fill="#515F7B"
      />
      <path
        d="M11 10.1667C11.7364 10.1667 12.3333 9.56971 12.3333 8.83333C12.3333 8.09695 11.7364 7.5 11 7.5C10.2636 7.5 9.66666 8.09695 9.66666 8.83333C9.66666 9.56971 10.2636 10.1667 11 10.1667Z"
        fill="#515F7B"
      />
      <path
        d="M11 16.3332C11.7364 16.3332 12.3333 15.7362 12.3333 14.9998C12.3333 14.2635 11.7364 13.6665 11 13.6665C10.2636 13.6665 9.66666 14.2635 9.66666 14.9998C9.66666 15.7362 10.2636 16.3332 11 16.3332Z"
        fill="#515F7B"
      />
      <path
        d="M5.33333 22.4997C6.06971 22.4997 6.66667 21.9027 6.66667 21.1663C6.66667 20.43 6.06971 19.833 5.33333 19.833C4.59695 19.833 4 20.43 4 21.1663C4 21.9027 4.59695 22.4997 5.33333 22.4997Z"
        fill="#515F7B"
      />
      <path
        d="M11 22.4997C11.7364 22.4997 12.3333 21.9027 12.3333 21.1663C12.3333 20.43 11.7364 19.833 11 19.833C10.2636 19.833 9.66666 20.43 9.66666 21.1663C9.66666 21.9027 10.2636 22.4997 11 22.4997Z"
        fill="#515F7B"
      />
    </svg>
  );
}
export function BookMarkIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.7">
        <path
          d="M12.3434 1.86155H12.3434L12.3154 1.86155C10.6896 1.86128 9.66213 1.86111 8.80123 2.14798C7.06413 2.72683 5.70387 4.12291 5.14038 5.90147C4.86112 6.78292 4.86129 7.83518 4.86155 9.50414L4.86155 9.53109V9.53111L4.86157 17.0572L4.86157 17.0632C4.86156 17.981 4.86156 18.7228 4.90558 19.296C4.94886 19.8594 5.04185 20.4207 5.33937 20.873C5.92343 21.761 6.94284 22.2428 7.98349 22.1194C8.5141 22.0564 8.9915 21.7625 9.43689 21.4294C9.89012 21.0905 10.4394 20.6076 11.1188 20.0104L11.1233 20.0064L11.1483 19.9844C11.4832 19.6901 11.6947 19.5083 11.8446 19.3919C11.9937 19.2761 12.0733 19.232 12.1442 19.2063C12.3745 19.1229 12.6255 19.1229 12.8558 19.2063C12.9267 19.232 13.0063 19.2761 13.1554 19.3919C13.3053 19.5083 13.5168 19.6901 13.8517 19.9844L13.8767 20.0064L13.8812 20.0104C14.5605 20.6076 15.1099 21.0905 15.5631 21.4294C16.0085 21.7625 16.4859 22.0564 17.0165 22.1194C18.0572 22.2428 19.0766 21.761 19.6606 20.873C19.9582 20.4207 20.0511 19.8594 20.0944 19.296C20.1384 18.7228 20.1384 17.9811 20.1384 17.0634V17.0573L20.1384 9.53112V9.5311L20.1384 9.50417C20.1387 7.83519 20.1389 6.78293 19.8596 5.90147C19.2961 4.12291 17.9359 2.72683 16.1988 2.14798C15.3379 1.86111 14.3104 1.86128 12.6846 1.86155L12.6566 1.86155H12.6566H12.3434ZM9.33735 3.82655C9.61648 3.73354 9.93967 3.68291 10.4297 3.65625C10.9205 3.62955 11.5699 3.62721 12.5 3.62721C13.4301 3.62721 14.0795 3.62955 14.5703 3.65625C15.0603 3.68291 15.3835 3.73354 15.6627 3.82655C16.8717 4.22944 17.8213 5.20223 18.2151 6.44514C18.3993 7.0266 18.4099 7.77548 18.4099 9.69171V17.0235C18.4099 17.99 18.4093 18.6621 18.3712 19.1579C18.3317 19.6722 18.2591 19.8378 18.2259 19.8883C18.0014 20.2296 17.6116 20.4125 17.216 20.3655C17.159 20.3588 16.9906 20.3086 16.5842 20.0047C16.1926 19.7119 15.6949 19.2752 14.9792 18.6461L14.8833 18.5617L14.8833 18.5617L14.8678 18.5481C14.3562 18.0975 13.93 17.7221 13.4338 17.5423C12.8296 17.3233 12.1704 17.3233 11.5662 17.5423C11.07 17.7221 10.6438 18.0975 10.1322 18.5481L10.1167 18.5617L10.1167 18.5617L10.0208 18.6461C9.30514 19.2752 8.80736 19.7119 8.41582 20.0047C8.00942 20.3086 7.84095 20.3588 7.78403 20.3655C7.3884 20.4125 6.99863 20.2296 6.77415 19.8883C6.74092 19.8378 6.66832 19.6722 6.62882 19.1579C6.59074 18.6621 6.5901 17.99 6.5901 17.0235V9.69171C6.5901 7.77548 6.60072 7.02659 6.78493 6.44514C7.17871 5.20223 8.12829 4.22944 9.33735 3.82655Z"
          fill="#161E2E"
          stroke="#161E2E"
          strokeWidth="0.276923"
        />
      </g>
    </svg>
  );
}
export function BookMarkIconActive(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.7">
        <path
          d="M12.3434 1.86155H12.3434L12.3154 1.86155C10.6896 1.86128 9.66213 1.86111 8.80123 2.14798C7.06413 2.72683 5.70387 4.12291 5.14038 5.90147C4.86112 6.78292 4.86129 7.83518 4.86155 9.50414L4.86155 9.53109V9.53111L4.86157 17.0572L4.86157 17.0632C4.86156 17.981 4.86156 18.7228 4.90558 19.296C4.94886 19.8594 5.04185 20.4207 5.33937 20.873C5.92343 21.761 6.94283 22.2428 7.98349 22.1194C8.5141 22.0564 8.9915 21.7625 9.43689 21.4294C9.89012 21.0905 10.4394 20.6076 11.1188 20.0104L11.1233 20.0064L11.1483 19.9844C11.4832 19.6901 11.6947 19.5083 11.8446 19.3919C11.9937 19.2761 12.0733 19.232 12.1442 19.2063C12.3745 19.1229 12.6255 19.1229 12.8558 19.2063C12.9267 19.232 13.0063 19.2761 13.1554 19.3919C13.3053 19.5083 13.5168 19.6901 13.8517 19.9844L13.8767 20.0064L13.8812 20.0104C14.5606 20.6076 15.1099 21.0905 15.5631 21.4294C16.0085 21.7625 16.4859 22.0564 17.0165 22.1194C18.0572 22.2428 19.0766 21.761 19.6606 20.873C19.9582 20.4207 20.0511 19.8594 20.0944 19.296C20.1384 18.7228 20.1384 17.981 20.1384 17.0632V17.0573L20.1384 9.53112V9.5311L20.1384 9.50417C20.1387 7.83519 20.1389 6.78293 19.8596 5.90147C19.2961 4.12291 17.9359 2.72683 16.1988 2.14798C15.3379 1.86111 14.3104 1.86128 12.6846 1.86155L12.6566 1.86155H12.6566H12.3434Z"
          fill="#186CCE"
          stroke="#186CCE"
          strokeWidth="0.276923"
        />
      </g>
    </svg>
  );
}
export function FilterIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M14 9.75H5C4.55 9.75 4.25 9.45 4.25 9C4.25 8.55 4.55 8.25 5 8.25H14C14.45 8.25 14.75 8.55 14.75 9C14.75 9.45 14.45 9.75 14 9.75Z"
        fill="#186CCE"
      />
      <path
        d="M11.75 14.25H7.25C6.8 14.25 6.5 13.95 6.5 13.5C6.5 13.05 6.8 12.75 7.25 12.75H11.75C12.2 12.75 12.5 13.05 12.5 13.5C12.5 13.95 12.2 14.25 11.75 14.25Z"
        fill="#186CCE"
      />
      <path
        d="M16.25 5.25H2.75C2.3 5.25 2 4.95 2 4.5C2 4.05 2.3 3.75 2.75 3.75H16.25C16.7 3.75 17 4.05 17 4.5C17 4.95 16.7 5.25 16.25 5.25Z"
        fill="#186CCE"
      />
    </svg>
  );
}
export function PlayIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.dimensions}
      viewBox="0 0 41 41"
      fill="none"
    >
      <circle cx="20.5" cy="20.5" r="20.5" fill="#186CCE" />
      <path
        d="M14.0221 29.5198C13.707 29.5198 13.3936 29.4337 13.1163 29.2632C12.8669 29.1085 12.6611 28.8927 12.5183 28.6363C12.3754 28.3799 12.3003 28.0913 12.3 27.7978V14.0215C12.3 13.424 12.61 12.8695 13.1163 12.5561C13.3662 12.4024 13.6512 12.3148 13.9443 12.3016C14.2374 12.2883 14.5291 12.3498 14.7919 12.4803L28.5683 19.3684C28.8543 19.5117 29.0948 19.7318 29.2629 20.0039C29.431 20.2761 29.52 20.5897 29.52 20.9096C29.52 21.2296 29.431 21.5432 29.2629 21.8154C29.0948 22.0875 28.8543 22.3076 28.5683 22.4509L14.7919 29.339C14.5508 29.4595 14.2839 29.5198 14.0221 29.5198Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function PauseIcon(props) {
  return (
    <svg
      className={props.dimensions}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.5" cy="20.5" r="20.5" fill="#186CCE" />
      <path
        d="M25 9C24.2044 9 23.4413 9.34768 22.8787 9.96655C22.3161 10.5854 22 11.4248 22 12.3V27.7C22 28.5752 22.3161 29.4146 22.8787 30.0335C23.4413 30.6523 24.2044 31 25 31C25.7956 31 26.5587 30.6523 27.1213 30.0335C27.6839 29.4146 28 28.5752 28 27.7V12.3C28 11.4248 27.6839 10.5854 27.1213 9.96655C26.5587 9.34768 25.7956 9 25 9ZM26 27.7C26 27.9917 25.8946 28.2715 25.7071 28.4778C25.5196 28.6841 25.2652 28.8 25 28.8C24.7348 28.8 24.4804 28.6841 24.2929 28.4778C24.1054 28.2715 24 27.9917 24 27.7V12.3C24 12.0083 24.1054 11.7285 24.2929 11.5222C24.4804 11.3159 24.7348 11.2 25 11.2C25.2652 11.2 25.5196 11.3159 25.7071 11.5222C25.8946 11.7285 26 12.0083 26 12.3V27.7ZM17 9C16.2044 9 15.4413 9.34768 14.8787 9.96655C14.3161 10.5854 14 11.4248 14 12.3V27.7C14 28.5752 14.3161 29.4146 14.8787 30.0335C15.4413 30.6523 16.2044 31 17 31C17.7956 31 18.5587 30.6523 19.1213 30.0335C19.6839 29.4146 20 28.5752 20 27.7V12.3C20 11.4248 19.6839 10.5854 19.1213 9.96655C18.5587 9.34768 17.7956 9 17 9ZM18 27.7C18 27.9917 17.8946 28.2715 17.7071 28.4778C17.5196 28.6841 17.2652 28.8 17 28.8C16.7348 28.8 16.4804 28.6841 16.2929 28.4778C16.1054 28.2715 16 27.9917 16 27.7V12.3C16 12.0083 16.1054 11.7285 16.2929 11.5222C16.4804 11.3159 16.7348 11.2 17 11.2C17.2652 11.2 17.5196 11.3159 17.7071 11.5222C17.8946 11.7285 18 12.0083 18 12.3V27.7Z"
        fill="#F9F9F9"
      />
      <path
        d="M18 27.7C18 27.9917 17.8946 28.2715 17.7071 28.4778C17.5196 28.6841 17.2652 28.8 17 28.8C16.7348 28.8 16.4804 28.6841 16.2929 28.4778C16.1054 28.2715 16 27.9917 16 27.7V12.3C16 12.0083 16.1054 11.7285 16.2929 11.5222C16.4804 11.3159 16.7348 11.2 17 11.2C17.2652 11.2 17.5196 11.3159 17.7071 11.5222C17.8946 11.7285 18 12.0083 18 12.3V27.7Z"
        fill="#F9F9F9"
      />
      <path
        d="M26 27.7C26 27.9917 25.8946 28.2715 25.7071 28.4778C25.5196 28.6841 25.2652 28.8 25 28.8C24.7348 28.8 24.4804 28.6841 24.2929 28.4778C24.1054 28.2715 24 27.9917 24 27.7V12.3C24 12.0083 24.1054 11.7285 24.2929 11.5222C24.4804 11.3159 24.7348 11.2 25 11.2C25.2652 11.2 25.5196 11.3159 25.7071 11.5222C25.8946 11.7285 26 12.0083 26 12.3V27.7Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function VolumeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <mask id="path-1-inside-1_4260_3219" fill="white">
        <path d="M11.1676 0.169691L5.59589 3.23661C5.39353 3.34805 5.16751 3.40637 4.93792 3.40639H1.39346C1.0239 3.40641 0.669492 3.55726 0.408174 3.82576C0.146855 4.09425 3.21346e-05 4.45841 0 4.83814V12.1618C1.46069e-05 12.5415 0.14683 12.9057 0.40815 13.1742C0.669471 13.4427 1.02389 13.5936 1.39346 13.5936H4.93792C5.1675 13.5936 5.39351 13.6519 5.59589 13.7633L11.1676 16.8303C11.3799 16.9472 11.6181 17.0055 11.8589 16.9996C12.0997 16.9937 12.3348 16.9238 12.5415 16.7966C12.7481 16.6695 12.9192 16.4895 13.0379 16.2742C13.1567 16.0589 13.2191 15.8156 13.2191 15.5682V1.43176C13.2191 1.18429 13.1566 0.941047 13.0379 0.725756C12.9191 0.510465 12.7481 0.330479 12.5414 0.203354C12.3348 0.0762291 12.0996 0.00630669 11.8589 0.000407014C11.6181 -0.00549266 11.3799 0.0528318 11.1676 0.169691ZM16.9081 4.92519C16.8668 4.86415 16.8143 4.81206 16.7535 4.77189C16.6926 4.73171 16.6247 4.70425 16.5535 4.69106C16.4823 4.67787 16.4093 4.67921 16.3386 4.69501C16.268 4.71081 16.201 4.74076 16.1416 4.78315C16.0822 4.82554 16.0315 4.87953 15.9924 4.94205C15.9533 5.00457 15.9266 5.07439 15.9137 5.14752C15.9009 5.22066 15.9022 5.29567 15.9176 5.36829C15.933 5.4409 15.9621 5.5097 16.0034 5.57074C16.586 6.43023 16.8984 7.45254 16.8984 8.5C16.8984 9.54746 16.586 10.5698 16.0034 11.4293C15.9621 11.4903 15.933 11.5591 15.9176 11.6317C15.9022 11.7043 15.9009 11.7793 15.9137 11.8525C15.9266 11.9256 15.9533 11.9954 15.9924 12.0579C16.0315 12.1205 16.0822 12.1745 16.1416 12.2168C16.201 12.2592 16.268 12.2892 16.3386 12.305C16.4093 12.3208 16.4823 12.3221 16.5535 12.3089C16.6247 12.2957 16.6926 12.2683 16.7535 12.2281C16.8143 12.1879 16.8668 12.1358 16.9081 12.0748C17.6189 11.0258 18 9.77824 18 8.5C18 7.22176 17.6189 5.97419 16.9081 4.92519Z" />
      </mask>
      <path
        d="M11.1676 0.169691L11.891 1.48377L11.891 1.48376L11.1676 0.169691ZM5.59589 3.23661L4.87257 1.92253L4.87229 1.92268L5.59589 3.23661ZM4.93792 3.40639V4.90639H4.93806L4.93792 3.40639ZM1.39346 3.40639V1.90639H1.3934L1.39346 3.40639ZM0 4.83814L-1.5 4.83801V4.83814H0ZM0 12.1618H-1.5V12.1618L0 12.1618ZM1.39346 13.5936L1.3934 15.0936H1.39346V13.5936ZM4.93792 13.5936L4.93803 12.0936H4.93792V13.5936ZM5.59589 13.7633L6.31923 12.4492L6.3191 12.4491L5.59589 13.7633ZM11.1676 16.8303L10.4443 18.1444L10.4443 18.1444L11.1676 16.8303ZM13.2191 15.5682H11.7191V15.5682L13.2191 15.5682ZM13.2191 1.43176H14.7191V1.43173L13.2191 1.43176ZM16.9081 4.92519L15.6653 5.76509L15.6663 5.76665L16.9081 4.92519ZM16.0034 5.57074L14.7606 6.41063L14.7618 6.41244L16.0034 5.57074ZM16.0034 11.4293L14.7618 10.5876L14.7606 10.5894L16.0034 11.4293ZM16.9081 12.0748L15.6663 11.2333L15.6653 11.2349L16.9081 12.0748ZM10.4443 -1.14439L4.87257 1.92253L6.31921 4.55069L11.891 1.48377L10.4443 -1.14439ZM4.87229 1.92268C4.8901 1.91287 4.91275 1.9064 4.93778 1.90639L4.93806 4.90639C5.42227 4.90635 5.89697 4.78322 6.31949 4.55053L4.87229 1.92268ZM4.93792 1.90639H1.39346V4.90639H4.93792V1.90639ZM1.3934 1.90639C0.612707 1.90643 -0.127489 2.22548 -0.666762 2.77957L1.48311 4.87194C1.46647 4.88904 1.4351 4.90639 1.39352 4.90639L1.3934 1.90639ZM-0.666762 2.77957C-1.20469 3.33227 -1.49994 4.07344 -1.5 4.83801L1.5 4.83827C1.5 4.84167 1.49936 4.846 1.49729 4.85114C1.49521 4.8563 1.49104 4.8638 1.48311 4.87194L-0.666762 2.77957ZM-1.5 4.83814V12.1618H1.5V4.83814H-1.5ZM-1.5 12.1618C-1.49997 12.9264 -1.20474 13.6676 -0.666811 14.2204L1.48311 12.1281C1.49104 12.1362 1.49521 12.1437 1.49729 12.1489C1.49936 12.154 1.5 12.1583 1.5 12.1617L-1.5 12.1618ZM-0.666811 14.2204C-0.127534 14.7745 0.612683 15.0936 1.3934 15.0936L1.39352 12.0936C1.4351 12.0936 1.46648 12.111 1.48311 12.1281L-0.666811 14.2204ZM1.39346 15.0936H4.93792V12.0936H1.39346V15.0936ZM4.93782 15.0936C4.91291 15.0936 4.89038 15.0872 4.87268 15.0774L6.3191 12.4491C5.89664 12.2166 5.42209 12.0936 4.93803 12.0936L4.93782 15.0936ZM4.87255 15.0773L10.4443 18.1444L11.891 15.5162L6.31923 12.4492L4.87255 15.0773ZM10.4443 18.1444C10.8876 18.3884 11.3878 18.5116 11.8956 18.4991L11.8221 15.5C11.8484 15.4994 11.8723 15.506 11.891 15.5162L10.4443 18.1444ZM11.8956 18.4991C12.4034 18.4867 12.8968 18.3391 13.3275 18.0742L11.7555 15.5191C11.7728 15.5084 11.7959 15.5007 11.8221 15.5L11.8956 18.4991ZM13.3275 18.0742C13.7578 17.8094 14.1093 17.4376 14.3514 16.9987L11.7245 15.5497C11.7291 15.5414 11.7384 15.5296 11.7555 15.5191L13.3275 18.0742ZM14.3514 16.9987C14.5933 16.56 14.7191 16.0673 14.7191 15.5681L11.7191 15.5682C11.7191 15.564 11.72 15.5578 11.7245 15.5497L14.3514 16.9987ZM14.7191 15.5682V1.43176H11.7191V15.5682H14.7191ZM14.7191 1.43173C14.7191 0.932599 14.5933 0.439883 14.3513 0.00122996L11.7245 1.45028C11.72 1.44221 11.7191 1.43598 11.7191 1.43179L14.7191 1.43173ZM14.3513 0.00122996C14.1092 -0.437657 13.7578 -0.809479 13.3274 -1.07423L11.7555 1.48094C11.7384 1.47044 11.729 1.45859 11.7245 1.45028L14.3513 0.00122996ZM13.3274 -1.07423C12.8968 -1.33917 12.4034 -1.4867 11.8956 -1.49914L11.8221 1.49996C11.7959 1.49931 11.7728 1.49163 11.7555 1.48094L13.3274 -1.07423ZM11.8956 -1.49914C11.3878 -1.51159 10.8876 -1.38838 10.4443 -1.14438L11.891 1.48376C11.8723 1.49405 11.8484 1.5006 11.8221 1.49996L11.8956 -1.49914ZM18.1509 4.0853C18.0005 3.8627 17.807 3.67005 17.5799 3.52012L15.927 6.02365C15.8216 5.95406 15.7332 5.86561 15.6653 5.76509L18.1509 4.0853ZM17.5799 3.52012C17.3527 3.37012 17.0969 3.26622 16.8268 3.21617L16.2802 6.16595C16.1524 6.14227 16.0325 6.09331 15.927 6.02365L17.5799 3.52012ZM16.8268 3.21617C16.5566 3.1661 16.2793 3.17123 16.0113 3.23116L16.6659 6.15887C16.5393 6.18719 16.408 6.18963 16.2802 6.16595L16.8268 3.21617ZM16.0113 3.23116C15.7434 3.29107 15.4917 3.40417 15.2704 3.56211L17.0128 6.00419C16.9103 6.07735 16.7926 6.13056 16.6659 6.15887L16.0113 3.23116ZM15.2704 3.56211C15.0491 3.71997 14.8629 3.91918 14.7206 4.14673L17.2642 5.73738C17.2001 5.83988 17.1153 5.9311 17.0128 6.00419L15.2704 3.56211ZM14.7206 4.14673C14.5784 4.37419 14.4823 4.6262 14.4363 4.88821L17.3912 5.40684C17.3708 5.52258 17.3283 5.63495 17.2642 5.73738L14.7206 4.14673ZM14.4363 4.88821C14.3903 5.15018 14.395 5.41873 14.4501 5.67906L17.385 5.05752C17.4094 5.17262 17.4115 5.29113 17.3912 5.40684L14.4363 4.88821ZM14.4501 5.67906C14.5053 5.93943 14.6102 6.18812 14.7606 6.41063L17.2462 4.73084C17.314 4.83127 17.3607 4.94238 17.385 5.05752L14.4501 5.67906ZM14.7618 6.41244C15.1745 7.02122 15.3984 7.74983 15.3984 8.5H18.3984C18.3984 7.15524 17.9976 5.83923 17.245 4.72903L14.7618 6.41244ZM15.3984 8.5C15.3984 9.25016 15.1745 9.97878 14.7618 10.5876L17.245 12.271C17.9976 11.1608 18.3984 9.84476 18.3984 8.5H15.3984ZM14.7606 10.5894C14.6102 10.8119 14.5053 11.0606 14.4501 11.3209L17.385 11.9425C17.3607 12.0576 17.314 12.1687 17.2462 12.2692L14.7606 10.5894ZM14.4501 11.3209C14.395 11.5813 14.3903 11.8498 14.4363 12.1118L17.3912 11.5932C17.4115 11.7089 17.4094 11.8274 17.385 11.9425L14.4501 11.3209ZM14.4363 12.1118C14.4823 12.3738 14.5784 12.6258 14.7206 12.8533L17.2642 11.2626C17.3282 11.365 17.3708 11.4774 17.3912 11.5932L14.4363 12.1118ZM14.7206 12.8533C14.8629 13.0808 15.0491 13.28 15.2704 13.4379L17.0128 10.9958C17.1153 11.0689 17.2001 11.1601 17.2642 11.2626L14.7206 12.8533ZM15.2704 13.4379C15.4917 13.5958 15.7434 13.7089 16.0113 13.7688L16.6659 10.8411C16.7925 10.8694 16.9103 10.9226 17.0128 10.9958L15.2704 13.4379ZM16.0113 13.7688C16.2793 13.8288 16.5567 13.8339 16.8268 13.7838L16.2802 10.8341C16.408 10.8104 16.5393 10.8128 16.6659 10.8411L16.0113 13.7688ZM16.8268 13.7838C17.0969 13.7338 17.3527 13.6299 17.5799 13.4799L15.927 10.9763C16.0325 10.9067 16.1524 10.8577 16.2802 10.8341L16.8268 13.7838ZM17.5799 13.4799C17.807 13.3299 18.0005 13.1373 18.1509 12.9147L15.6653 11.2349C15.7332 11.1344 15.8216 11.0459 15.927 10.9763L17.5799 13.4799ZM18.1498 12.9163C19.0306 11.6166 19.5 10.0754 19.5 8.5H16.5C16.5 9.48104 16.2073 10.435 15.6663 11.2333L18.1498 12.9163ZM19.5 8.5C19.5 6.92456 19.0306 5.38339 18.1498 4.08373L15.6663 5.76665C16.2073 6.56499 16.5 7.51896 16.5 8.5H19.5Z"
        fill="#F9F9F9"
        mask="url(#path-1-inside-1_4260_3219)"
      />
    </svg>
  );
}
export function VolumeMuteIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
    >
      <path
        d="M11.168 0.170407L11.5293 0.826731L5.95769 3.89357C5.95764 3.8936 5.9576 3.89362 5.95755 3.89365C5.64515 4.06566 5.29484 4.15636 4.93799 4.15639L4.93792 4.15639L1.39349 4.15639C1.39348 4.15639 1.39347 4.15639 1.39346 4.15639C1.22948 4.15641 1.06798 4.22315 0.945642 4.34885C0.822641 4.47523 0.750032 4.65086 0.75 4.83814L11.168 0.170407ZM11.168 0.170407L11.5293 0.826728C11.6261 0.773439 11.7332 0.747554 11.8405 0.750182C11.9478 0.75281 12.0538 0.783929 12.1485 0.842146C12.2432 0.900457 12.3241 0.984526 12.3812 1.08802C12.4383 1.19163 12.4691 1.31014 12.4691 1.43176V15.5682V15.5682C12.4691 15.6898 12.4383 15.8083 12.3812 15.912C12.3241 16.0155 12.2433 16.0995 12.1485 16.1578C12.0538 16.2161 11.9478 16.2472 11.8405 16.2498C11.7332 16.2524 11.6261 16.2266 11.5293 16.1733L5.95756 13.1062L5.95749 13.1062C5.64508 12.9343 5.29479 12.8436 4.93797 12.8436H4.93792M11.168 0.170407L4.93792 12.8436M4.93792 12.8436H1.39349C1.39348 12.8436 1.39347 12.8436 1.39346 12.8436C1.22948 12.8436 1.06797 12.7768 0.945631 12.6511C0.822621 12.5247 0.750015 12.3491 0.75 12.1618C0.75 12.1618 0.75 12.1618 0.75 12.1618M4.93792 12.8436L0.75 12.1618M0.75 12.1618V4.8382V12.1618Z"
        stroke="#F9F9F9"
        strokeWidth="1.5"
      />
      <path
        d="M20.549 10.531C20.8303 10.8122 20.8303 11.2678 20.549 11.549C20.4084 11.6897 20.2243 11.76 20.04 11.76C19.8557 11.76 19.6716 11.6897 19.531 11.549L17.88 9.89808L16.229 11.549C16.0884 11.6897 15.9043 11.76 15.72 11.76C15.5357 11.76 15.3516 11.6897 15.211 11.549C14.9297 11.2678 14.9297 10.8122 15.211 10.531L16.8619 8.88L15.211 7.22904C14.9297 6.94776 14.9297 6.49224 15.211 6.21096C15.4922 5.92968 15.9478 5.92968 16.229 6.21096L17.88 7.86192L19.531 6.21096C19.8122 5.92968 20.2678 5.92968 20.549 6.21096C20.8303 6.49224 20.8303 6.94776 20.549 7.22904L18.8981 8.88L20.549 10.531Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function ForwardIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6526 10.1925L13.5376 3.44255C13.2679 3.21813 12.9401 3.07488 12.5922 3.02949C12.2444 2.9841 11.8908 3.03842 11.5726 3.18613C11.2544 3.33384 10.9846 3.56887 10.7948 3.86388C10.6049 4.15888 10.5027 4.50174 10.5001 4.85255V8.40005L4.5376 3.42755C4.26644 3.21353 3.94085 3.07959 3.59759 3.04085C3.25432 3.00212 2.90707 3.06013 2.59504 3.20835C2.28301 3.35656 2.01864 3.58907 1.83178 3.87961C1.64493 4.17015 1.54303 4.50715 1.5376 4.85255V19.1475C1.53739 19.4996 1.63753 19.8445 1.82627 20.1417C2.01501 20.4389 2.28455 20.6762 2.6033 20.8257C2.92206 20.9753 3.27682 21.0309 3.62604 20.986C3.97526 20.9412 4.30447 20.7978 4.5751 20.5725L10.5751 15.6V19.1475C10.5749 19.4996 10.675 19.8445 10.8638 20.1417C11.0525 20.4389 11.3221 20.6762 11.6408 20.8257C11.9596 20.9753 12.3143 21.0309 12.6635 20.986C13.0128 20.9412 13.342 20.7978 13.6126 20.5725L21.7276 13.8225C21.9934 13.6023 22.2074 13.3261 22.3542 13.0137C22.5011 12.7012 22.5772 12.3603 22.5772 12.015C22.5772 11.6698 22.5011 11.3289 22.3542 11.0164C22.2074 10.704 21.9934 10.4278 21.7276 10.2075L21.6526 10.1925Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function RewindIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.3474 10.1925L10.4624 3.44255C10.7321 3.21813 11.0599 3.07488 11.4078 3.02949C11.7556 2.9841 12.1092 3.03842 12.4274 3.18613C12.7456 3.33384 13.0154 3.56887 13.2052 3.86388C13.3951 4.15888 13.4973 4.50174 13.4999 4.85255V8.40005L19.4624 3.42755C19.7336 3.21353 20.0592 3.07959 20.4024 3.04085C20.7457 3.00212 21.0929 3.06013 21.405 3.20835C21.717 3.35656 21.9814 3.58907 22.1682 3.87961C22.3551 4.17015 22.457 4.50715 22.4624 4.85255V19.1475C22.4626 19.4996 22.3625 19.8445 22.1737 20.1417C21.985 20.4389 21.7154 20.6762 21.3967 20.8257C21.0779 20.9753 20.7232 21.0309 20.374 20.986C20.0247 20.9412 19.6955 20.7978 19.4249 20.5725L13.4249 15.6V19.1475C13.4251 19.4996 13.325 19.8445 13.1362 20.1417C12.9475 20.4389 12.6779 20.6762 12.3592 20.8257C12.0404 20.9753 11.6857 21.0309 11.3365 20.986C10.9872 20.9412 10.658 20.7978 10.3874 20.5725L2.2724 13.8225C2.0066 13.6023 1.79265 13.3261 1.64579 13.0137C1.49894 12.7012 1.4228 12.3603 1.4228 12.015C1.4228 11.6698 1.49894 11.3289 1.64579 11.0164C1.79265 10.704 2.0066 10.4278 2.2724 10.2075L2.3474 10.1925Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function LoopIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 13C3.73478 13 3.48043 12.8946 3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12V9C3 8.20435 3.31607 7.44129 3.87868 6.87868C4.44129 6.31607 5.20435 6 6 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7C20 7.26522 19.8946 7.51957 19.7071 7.70711C19.5196 7.89464 19.2652 8 19 8H6C5.73478 8 5.48043 8.10536 5.29289 8.29289C5.10536 8.48043 5 8.73478 5 9V12C5 12.2652 4.89464 12.5196 4.70711 12.7071C4.51957 12.8946 4.26522 13 4 13Z"
        fill="#F9F9F9"
      />
      <path
        d="M17 11C16.8023 11 16.609 10.9413 16.4446 10.8314C16.2802 10.7216 16.152 10.5654 16.0764 10.3827C16.0007 10.2 15.9809 9.99896 16.0194 9.80501C16.058 9.61106 16.1532 9.43289 16.293 9.29304L18.586 7.00004L16.293 4.70704C16.1109 4.51844 16.0101 4.26584 16.0124 4.00364C16.0146 3.74144 16.1198 3.49063 16.3052 3.30522C16.4906 3.11981 16.7414 3.01465 17.0036 3.01237C17.2658 3.01009 17.5184 3.11088 17.707 3.29304L20.707 6.29304C20.8945 6.48057 20.9998 6.73488 20.9998 7.00004C20.9998 7.26521 20.8945 7.51951 20.707 7.70704L17.707 10.707C17.5195 10.8946 17.2652 11 17 11Z"
        fill="#F9F9F9"
      />
      <path
        d="M18 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17C4 16.7348 4.10536 16.4804 4.29289 16.2929C4.48043 16.1054 4.73478 16 5 16H18C18.2652 16 18.5196 15.8946 18.7071 15.7071C18.8946 15.5196 19 15.2652 19 15V12C19 11.7348 19.1054 11.4804 19.2929 11.2929C19.4804 11.1054 19.7348 11 20 11C20.2652 11 20.5196 11.1054 20.7071 11.2929C20.8946 11.4804 21 11.7348 21 12V15C21 15.7957 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18Z"
        fill="#F9F9F9"
      />
      <path
        d="M7.00003 21C6.73484 21 6.48052 20.8946 6.29303 20.707L3.29303 17.707C3.10556 17.5195 3.00024 17.2652 3.00024 17C3.00024 16.7349 3.10556 16.4806 3.29303 16.293L6.29303 13.293C6.48163 13.1109 6.73424 13.0101 6.99643 13.0124C7.25863 13.0146 7.50944 13.1198 7.69485 13.3052C7.88026 13.4906 7.98543 13.7414 7.9877 14.0036C7.98998 14.2658 7.88919 14.5184 7.70703 14.707L5.41403 17L7.70703 19.293C7.84684 19.4329 7.94205 19.6111 7.98061 19.805C8.01918 19.999 7.99938 20.2 7.92371 20.3827C7.84804 20.5654 7.7199 20.7216 7.55549 20.8314C7.39108 20.9413 7.19778 21 7.00003 21Z"
        fill="#F9F9F9"
      />
    </svg>
  );
}
export function LoopOffIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 13C3.73478 13 3.48043 12.8946 3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12V9C3 8.20435 3.31607 7.44129 3.87868 6.87868C4.44129 6.31607 5.20435 6 6 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7C20 7.26522 19.8946 7.51957 19.7071 7.70711C19.5196 7.89464 19.2652 8 19 8H6C5.73478 8 5.48043 8.10536 5.29289 8.29289C5.10536 8.48043 5 8.73478 5 9V12C5 12.2652 4.89464 12.5196 4.70711 12.7071C4.51957 12.8946 4.26522 13 4 13Z"
        fill="#F9F9F9"
      />
      <path
        d="M17 11C16.8023 11 16.609 10.9413 16.4446 10.8314C16.2802 10.7216 16.152 10.5654 16.0764 10.3827C16.0007 10.2 15.9809 9.99896 16.0194 9.80501C16.058 9.61106 16.1532 9.43289 16.293 9.29304L18.586 7.00004L16.293 4.70704C16.1109 4.51844 16.0101 4.26584 16.0124 4.00364C16.0146 3.74144 16.1198 3.49063 16.3052 3.30522C16.4906 3.11981 16.7414 3.01465 17.0036 3.01237C17.2658 3.01009 17.5184 3.11088 17.707 3.29304L20.707 6.29304C20.8945 6.48057 20.9998 6.73488 20.9998 7.00004C20.9998 7.26521 20.8945 7.51951 20.707 7.70704L17.707 10.707C17.5195 10.8946 17.2652 11 17 11Z"
        fill="#F9F9F9"
      />
      <path
        d="M18 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17C4 16.7348 4.10536 16.4804 4.29289 16.2929C4.48043 16.1054 4.73478 16 5 16H18C18.2652 16 18.5196 15.8946 18.7071 15.7071C18.8946 15.5196 19 15.2652 19 15V12C19 11.7348 19.1054 11.4804 19.2929 11.2929C19.4804 11.1054 19.7348 11 20 11C20.2652 11 20.5196 11.1054 20.7071 11.2929C20.8946 11.4804 21 11.7348 21 12V15C21 15.7957 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18Z"
        fill="#F9F9F9"
      />
      <path
        d="M7.00003 21C6.73484 21 6.48052 20.8946 6.29303 20.707L3.29303 17.707C3.10556 17.5195 3.00024 17.2652 3.00024 17C3.00024 16.7349 3.10556 16.4806 3.29303 16.293L6.29303 13.293C6.48163 13.1109 6.73424 13.0101 6.99643 13.0124C7.25863 13.0146 7.50944 13.1198 7.69485 13.3052C7.88026 13.4906 7.98543 13.7414 7.9877 14.0036C7.98998 14.2658 7.88919 14.5184 7.70703 14.707L5.41403 17L7.70703 19.293C7.84684 19.4329 7.94205 19.6111 7.98061 19.805C8.01918 19.999 7.99938 20.2 7.92371 20.3827C7.84804 20.5654 7.7199 20.7216 7.55549 20.8314C7.39108 20.9413 7.19778 21 7.00003 21Z"
        fill="#F9F9F9"
      />
      <path
        d="M3 3L21 21"
        stroke="#F9F9F9"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
export function GoogleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M6.42014 15.4652L5.59739 18.5366L2.59026 18.6003C1.69158 16.9334 1.18182 15.0263 1.18182 12.9996C1.18182 11.0399 1.65843 9.19184 2.50324 7.56458H2.50389L5.18108 8.0554L6.35385 10.7165C6.10839 11.4321 5.9746 12.2003 5.9746 12.9996C5.9747 13.8672 6.13184 14.6984 6.42014 15.4652Z"
        fill="#FBBB00"
      />
      <path
        d="M24.6117 10.7921C24.7474 11.507 24.8182 12.2453 24.8182 12.9999C24.8182 13.846 24.7292 14.6713 24.5598 15.4675C23.9845 18.1765 22.4812 20.5421 20.3987 22.2161L20.3981 22.2155L17.026 22.0434L16.5488 19.0642C17.9306 18.2538 19.0105 16.9856 19.5793 15.4675H13.2598V10.7921H19.6715H24.6117Z"
        fill="#518EF8"
      />
      <path
        d="M20.3981 22.2159L20.3987 22.2166C18.3734 23.8445 15.8006 24.8185 13 24.8185C8.49936 24.8185 4.58639 22.3029 2.59027 18.601L6.42015 15.4659C7.41818 18.1296 9.98767 20.0257 13 20.0257C14.2948 20.0257 15.5078 19.6757 16.5487 19.0646L20.3981 22.2159Z"
        fill="#28B446"
      />
      <path
        d="M20.5436 3.90253L16.715 7.03693C15.6377 6.36357 14.3643 5.97459 13.0001 5.97459C9.91953 5.97459 7.30199 7.95769 6.35395 10.7168L2.50394 7.56487H2.5033C4.47019 3.77267 8.43252 1.18176 13.0001 1.18176C15.8676 1.18176 18.4968 2.2032 20.5436 3.90253Z"
        fill="#F14336"
      />
    </svg>
  );
}
export function AppleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="28"
      viewBox="0 0 26 28"
      fill="none"
    >
      <path
        d="M11.8414 6.46154C13.1172 6.46154 14.7164 5.60712 15.6687 4.4679C16.5312 3.43547 17.1602 1.99364 17.1602 0.551812C17.1602 0.356008 17.1422 0.160203 17.1062 0C15.6867 0.0534012 13.9797 0.943421 12.9555 2.13605C12.1469 3.04387 11.4102 4.4679 11.4102 5.92753C11.4102 6.14113 11.4461 6.35474 11.4641 6.42594C11.5539 6.44374 11.6977 6.46154 11.8414 6.46154ZM7.34922 28C9.09219 28 9.86484 26.843 12.0391 26.843C14.2492 26.843 14.7344 27.9644 16.675 27.9644C18.5797 27.9644 19.8555 26.22 21.0594 24.5111C22.407 22.5531 22.9641 20.6306 23 20.5416C22.8742 20.506 19.2266 19.0286 19.2266 14.8811C19.2266 11.2854 22.1016 9.66561 22.2633 9.541C20.3586 6.83535 17.4656 6.76414 16.675 6.76414C14.5367 6.76414 12.7937 8.04577 11.6977 8.04577C10.5117 8.04577 8.94844 6.83535 7.09766 6.83535C3.57578 6.83535 0 9.71901 0 15.1659C0 18.548 1.32969 22.1259 2.96484 24.4399C4.36641 26.398 5.58828 28 7.34922 28Z"
        fill="#000100"
      />
    </svg>
  );
}
export function XIcon(props) {
  return (
    <svg
      {...props}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      ></path>
    </svg>
  );
}
export function CalenderIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99695 1.87183C3.27106 1.87183 1.87195 3.27094 1.87195 4.99683V6.66529V15.0031C1.87195 16.729 3.27106 18.1281 4.99695 18.1281H15.0032C16.7291 18.1281 18.1282 16.729 18.1282 15.0031V6.66529V4.99683C18.1282 3.27094 16.7291 1.87183 15.0032 1.87183H4.99695ZM16.8782 6.04029V4.99683C16.8782 3.96129 16.0387 3.12183 15.0032 3.12183H4.99695C3.96141 3.12183 3.12195 3.96129 3.12195 4.99683V6.04029H16.8782ZM3.12195 7.29029H16.8782V15.0031C16.8782 16.0386 16.0387 16.8781 15.0032 16.8781H4.99695C3.96141 16.8781 3.12195 16.0386 3.12195 15.0031V7.29029Z"
        fill="#161E2E"
      />
      <path
        d="M15.0419 9.63077C15.0175 9.97677 14.7291 10.2499 14.3768 10.2499C14.0086 10.2499 13.7102 9.9514 13.7102 9.5832C13.7102 9.21961 14.0012 8.924 14.3631 8.91666L14.377 8.9165C14.7452 8.9165 15.0436 9.21499 15.0436 9.58319C15.0436 9.5992 15.043 9.61506 15.0419 9.63077Z"
        fill="#161E2E"
      />
      <path
        d="M11.4412 8.91673L11.4581 8.9165C11.812 8.9165 12.1015 9.19235 12.1234 9.54079C12.1244 9.55481 12.1248 9.56895 12.1248 9.5832C12.1248 9.9514 11.8263 10.2499 11.4581 10.2499C11.0899 10.2499 10.7915 9.9514 10.7915 9.5832C10.7915 9.22068 11.0808 8.92574 11.4412 8.91673Z"
        fill="#161E2E"
      />
      <path
        d="M8.52647 8.91666L8.54037 8.9165C8.90857 8.9165 9.20706 9.21499 9.20706 9.58319C9.20706 9.5992 9.20645 9.61506 9.20527 9.63077C9.18088 9.97677 8.89247 10.2499 8.54026 10.2499C8.17206 10.2499 7.87358 9.9514 7.87358 9.5832C7.87358 9.21961 8.16464 8.924 8.52647 8.91666Z"
        fill="#161E2E"
      />
      <path
        d="M5.60791 11.4177L5.62249 11.4175C5.99069 11.4175 6.28917 11.716 6.28917 12.0842C6.28917 12.1002 6.28857 12.1161 6.28739 12.1318C6.26299 12.4778 5.97458 12.7509 5.62237 12.7509C5.25417 12.7509 4.95569 12.4524 4.95569 12.0842C4.95569 11.7209 5.24639 11.4254 5.60791 11.4177Z"
        fill="#161E2E"
      />
      <path
        d="M8.52579 11.4177L8.54037 11.4175C8.90857 11.4175 9.20706 11.716 9.20706 12.0842C9.20706 12.1002 9.20645 12.1161 9.20527 12.1318C9.18088 12.4778 8.89247 12.7509 8.54026 12.7509C8.17206 12.7509 7.87358 12.4524 7.87358 12.0842C7.87358 11.7209 8.16427 11.4254 8.52579 11.4177Z"
        fill="#161E2E"
      />
      <path
        d="M11.4412 11.4177L11.4581 11.4175C11.812 11.4175 12.1015 11.6934 12.1234 12.0418C12.1244 12.0558 12.1248 12.07 12.1248 12.0842C12.1248 12.4524 11.8263 12.7509 11.4581 12.7509C11.0899 12.7509 10.7915 12.4524 10.7915 12.0842C10.7915 11.7217 11.0808 11.4267 11.4412 11.4177Z"
        fill="#161E2E"
      />
      <path
        d="M14.3624 11.4177L14.377 11.4175C14.7452 11.4175 15.0436 11.716 15.0436 12.0842C15.0436 12.1002 15.043 12.1161 15.0419 12.1318C15.0175 12.4778 14.7291 12.7509 14.3768 12.7509C14.0086 12.7509 13.7102 12.4524 13.7102 12.0842C13.7102 11.7209 14.0009 11.4254 14.3624 11.4177Z"
        fill="#161E2E"
      />
      <path
        d="M14.3624 13.9187L14.377 13.9185C14.7452 13.9185 15.0436 14.217 15.0436 14.5852C15.0436 14.6012 15.043 14.6171 15.0419 14.6328C15.0175 14.9788 14.7291 15.2519 14.3768 15.2519C14.0086 15.2519 13.7102 14.9534 13.7102 14.5852C13.7102 14.2219 14.0009 13.9264 14.3624 13.9187Z"
        fill="#161E2E"
      />
      <path
        d="M11.4411 13.9188L11.4581 13.9185C11.812 13.9185 12.1015 14.1944 12.1234 14.5428C12.1244 14.5568 12.1248 14.571 12.1248 14.5852C12.1248 14.9534 11.8263 15.2519 11.4581 15.2519C11.0899 15.2519 10.7915 14.9534 10.7915 14.5852C10.7915 14.2227 11.0808 13.9278 11.4411 13.9188Z"
        fill="#161E2E"
      />
      <path
        d="M8.52579 13.9187L8.54037 13.9185C8.90857 13.9185 9.20706 14.217 9.20706 14.5852C9.20706 14.6012 9.20645 14.6171 9.20527 14.6328C9.18088 14.9788 8.89247 15.2519 8.54026 15.2519C8.17206 15.2519 7.87358 14.9534 7.87358 14.5852C7.87358 14.2219 8.16427 13.9264 8.52579 13.9187Z"
        fill="#161E2E"
      />
      <path
        d="M5.60791 13.9187C5.61275 13.9186 5.61761 13.9185 5.62249 13.9185C5.99069 13.9185 6.28917 14.217 6.28917 14.5852C6.28917 14.6012 6.28857 14.6171 6.28739 14.6328C6.26299 14.9788 5.97458 15.2519 5.62237 15.2519C5.25417 15.2519 4.95569 14.9534 4.95569 14.5852C4.95569 14.2219 5.24639 13.9264 5.60791 13.9187Z"
        fill="#161E2E"
      />
    </svg>
  );
}
export function ProfileIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
}
export function RewindTen(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3193_6712)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.51691 12.2896C1.25706 12.1647 1.0918 11.9019 1.0918 11.6136C1.0918 5.67649 5.90474 0.863586 11.8418 0.863586C17.7789 0.863586 22.5918 5.67649 22.5918 11.6136C22.5918 15.1306 20.9021 18.2532 18.2933 20.2132C17.9621 20.462 17.492 20.3953 17.2432 20.0641C16.9943 19.7329 17.0611 19.2628 17.3923 19.014C19.6402 17.3251 21.0918 14.639 21.0918 11.6136C21.0918 6.50498 16.9504 2.36359 11.8418 2.36359C7.30778 2.36359 3.53566 5.62569 2.74446 9.93099L3.87328 9.02789C4.19673 8.76919 4.66869 8.82159 4.92745 9.14509C5.18621 9.46849 5.13377 9.94049 4.81032 10.1993L2.31032 12.1993C2.08519 12.3794 1.77676 12.4145 1.51691 12.2896ZM2.37361 14.9263C2.75317 14.7605 3.19531 14.9337 3.36115 15.3133C3.81459 16.3511 4.45333 17.2902 5.23594 18.0886C6.91562 19.802 9.25405 20.8636 11.8418 20.8636C12.4763 20.8636 13.0952 20.7998 13.6926 20.6785C14.0985 20.5961 14.4944 20.8584 14.5768 21.2643C14.6592 21.6703 14.3969 22.0662 13.991 22.1486C13.2959 22.2896 12.5771 22.3636 11.8418 22.3636C8.83476 22.3636 6.11496 21.1279 4.16479 19.1386C3.25634 18.2119 2.51403 17.121 1.98662 15.9139C1.82078 15.5343 1.99404 15.0922 2.37361 14.9263Z"
          fill="#F9F9F9"
        />
        <path
          d="M7.14873 15.4547V14.6005H8.71964V9.71108L7.49236 10.4769L7.08 9.72089L9.01418 8.53289H9.73091V14.6005H11.2036V15.4547H7.14873ZM14.8325 15.5431C14.0274 15.5431 13.4122 15.2387 12.9867 14.63C12.5678 14.0147 12.3583 13.1343 12.3583 11.9889C12.3583 10.8238 12.5678 9.94344 12.9867 9.3478C13.4122 8.74562 14.0274 8.44453 14.8325 8.44453C15.6442 8.44453 16.2594 8.74562 16.6783 9.3478C17.0973 9.94344 17.3067 10.8205 17.3067 11.9791C17.3067 13.1311 17.094 14.0147 16.6685 14.63C16.2496 15.2387 15.6376 15.5431 14.8325 15.5431ZM14.8325 14.6987C15.33 14.6987 15.6998 14.4794 15.942 14.0409C16.1842 13.6023 16.3053 12.9151 16.3053 11.9791C16.3053 11.0431 16.1842 10.3623 15.942 9.93689C15.7063 9.50489 15.3365 9.28889 14.8325 9.28889C14.3351 9.28889 13.9653 9.50489 13.7231 9.93689C13.4809 10.3689 13.3598 11.0496 13.3598 11.9791C13.3598 12.9151 13.4809 13.6023 13.7231 14.0409C13.9653 14.4794 14.3351 14.6987 14.8325 14.6987Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_3193_6712">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ForwordTen(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3193_6715)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1667 12.2896C22.4265 12.1647 22.5918 11.9019 22.5918 11.6136C22.5918 5.67649 17.7789 0.863586 11.8418 0.863586C5.9047 0.863586 1.0918 5.67649 1.0918 11.6136C1.0918 15.1306 2.7815 18.2532 5.3903 20.2132C5.7215 20.462 6.1916 20.3953 6.4404 20.0641C6.6893 19.7329 6.6225 19.2628 6.2913 19.014C4.0434 17.3251 2.5918 14.639 2.5918 11.6136C2.5918 6.50498 6.7332 2.36359 11.8418 2.36359C16.3758 2.36359 20.1479 5.62569 20.9391 9.93099L19.8103 9.02789C19.4869 8.76919 19.0149 8.82159 18.7561 9.14509C18.4974 9.46849 18.5498 9.94049 18.8733 10.1993L21.3733 12.1993C21.5984 12.3794 21.9068 12.4145 22.1667 12.2896ZM21.31 14.9263C20.9304 14.7605 20.4883 14.9337 20.3224 15.3133C19.869 16.3511 19.2303 17.2902 18.4477 18.0886C16.768 19.802 14.4295 20.8636 11.8418 20.8636C11.2073 20.8636 10.5884 20.7998 9.991 20.6785C9.5851 20.5961 9.1892 20.8584 9.1068 21.2643C9.0244 21.6703 9.2867 22.0662 9.6926 22.1486C10.3877 22.2896 11.1065 22.3636 11.8418 22.3636C14.8488 22.3636 17.5686 21.1279 19.5188 19.1386C20.4273 18.2119 21.1696 17.121 21.697 15.9139C21.8628 15.5343 21.6896 15.0922 21.31 14.9263Z"
          fill="#F9F9F9"
        />
        <path
          d="M7.14873 15.4547V14.6005H8.71964V9.71108L7.49236 10.4769L7.08 9.72089L9.01418 8.53289H9.73091V14.6005H11.2036V15.4547H7.14873ZM14.8325 15.5431C14.0274 15.5431 13.4122 15.2387 12.9867 14.63C12.5678 14.0147 12.3583 13.1343 12.3583 11.9889C12.3583 10.8238 12.5678 9.94344 12.9867 9.3478C13.4122 8.74562 14.0274 8.44453 14.8325 8.44453C15.6442 8.44453 16.2594 8.74562 16.6783 9.3478C17.0973 9.94344 17.3067 10.8205 17.3067 11.9791C17.3067 13.1311 17.094 14.0147 16.6685 14.63C16.2496 15.2387 15.6376 15.5431 14.8325 15.5431ZM14.8325 14.6987C15.33 14.6987 15.6998 14.4794 15.942 14.0409C16.1842 13.6023 16.3053 12.9151 16.3053 11.9791C16.3053 11.0431 16.1842 10.3623 15.942 9.93689C15.7063 9.50489 15.3365 9.28889 14.8325 9.28889C14.3351 9.28889 13.9653 9.50489 13.7231 9.93689C13.4809 10.3689 13.3598 11.0496 13.3598 11.9791C13.3598 12.9151 13.4809 13.6023 13.7231 14.0409C13.9653 14.4794 14.3351 14.6987 14.8325 14.6987Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_3193_6715">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function DownloadIcon(props) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#000000"
      strokeWidth="0.00024000000000000003"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0.24000000000000005"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25 12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25Z"
          fill="#ffffff"
        ></path>{" "}
        <path
          d="M7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z"
          fill="#ffffff"
        ></path>{" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9426 1.25C9.63423 1.24999 7.82519 1.24998 6.4137 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63423 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.4137 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25H11.9426ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62178 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62178 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
          fill="#ffffff"
        ></path>{" "}
      </g>
    </svg>
  );
}
export function ClassesIcon(props) {
  return (
    <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_326_587)">
        <path
          d="M25.3333 20V5.33334C25.3324 5.13306 25.2864 4.93557 25.1987 4.75552C25.111 4.57548 24.9838 4.4175 24.8267 4.29334C24.6718 4.16803 24.4908 4.07903 24.2969 4.03289C24.1031 3.98674 23.9014 3.98461 23.7067 4.02667L11.7067 6.69334C11.4104 6.76014 11.1459 6.92607 10.9568 7.16368C10.7676 7.40128 10.6653 7.69633 10.6667 8V19.12C9.75645 18.6903 8.73143 18.5673 7.74539 18.7695C6.75934 18.9717 5.86545 19.4882 5.19779 20.2414C4.53014 20.9947 4.12473 21.9441 4.04238 22.9473C3.96004 23.9505 4.20519 24.9533 4.74107 25.8054C5.27695 26.6574 6.07467 27.3127 7.01454 27.673C7.95441 28.0333 8.98576 28.0791 9.95388 27.8036C10.922 27.5281 11.7747 26.9461 12.384 26.1449C12.9933 25.3437 13.3264 24.3665 13.3333 23.36C13.3471 23.1291 13.3471 22.8976 13.3333 22.6667V9.06667L22.6667 7V16.4533C21.7559 16.0234 20.7303 15.9005 19.7438 16.1031C18.7572 16.3058 17.8631 16.823 17.1956 17.5772C16.528 18.3313 16.1232 19.2817 16.0419 20.2855C15.9606 21.2894 16.2071 22.2925 16.7445 23.1443C17.2819 23.996 18.0812 24.6505 19.0222 25.0093C19.9632 25.3681 20.9953 25.4119 21.9634 25.1342C22.9314 24.8564 23.7833 24.2721 24.3909 23.4689C24.9986 22.6657 25.3293 21.6871 25.3333 20.68C25.346 20.4535 25.346 20.2265 25.3333 20Z"
          fill="#161E2E"
        />
      </g>
    </svg>
  );
}
export function SeriesIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <path
        d="M5.89655 15H36.3103C37.0786 15 37.8153 15.3052 38.3585 15.8484C38.9017 16.3916 39.2069 17.1283 39.2069 17.8966V35.2759C39.2069 36.0441 38.9017 36.7808 38.3585 37.324C37.8153 37.8672 37.0786 38.1724 36.3103 38.1724H5.89655C5.12834 38.1724 4.39159 37.8672 3.84838 37.324C3.30517 36.7808 3 36.0441 3 35.2759V17.8966C3 17.1283 3.30517 16.3916 3.84838 15.8484C4.39159 15.3052 5.12834 15 5.89655 15Z"
        fill="#161E2E"
      />
      <path
        d="M25.4494 25.4119L17.9375 21.0719C17.7228 20.9448 17.4782 20.8769 17.2287 20.875C16.8366 20.875 16.4604 21.0308 16.1831 21.3081C15.9058 21.5854 15.75 21.9616 15.75 22.3537V31.6681C15.75 31.9284 15.8198 32.1839 15.952 32.408C16.0843 32.6322 16.2741 32.8169 16.5019 32.9428C16.7297 33.0687 16.987 33.1314 17.2472 33.1242C17.5073 33.117 17.7608 33.0402 17.9813 32.9019L25.5019 28.1506C25.7357 28.0043 25.9277 27.7998 26.059 27.5573C26.1903 27.3147 26.2566 27.0422 26.2513 26.7664C26.246 26.4906 26.1694 26.2208 26.0288 25.9835C25.8883 25.7461 25.6887 25.5492 25.4494 25.4119Z"
        fill="#D2D6DC"
      />
      <path
        d="M10.138 3.62067H31.8621C32.2462 3.62067 32.6146 3.77325 32.8862 4.04486C33.1578 4.31646 33.3104 4.68484 33.3104 5.06894C33.3104 5.45305 33.1578 5.82142 32.8862 6.09303C32.6146 6.36463 32.2462 6.51722 31.8621 6.51722H10.138C9.75387 6.51722 9.38549 6.36463 9.11389 6.09303C8.84228 5.82142 8.6897 5.45305 8.6897 5.06894C8.6897 4.68484 8.84228 4.31646 9.11389 4.04486C9.38549 3.77325 9.75387 3.62067 10.138 3.62067Z"
        fill="#161E2E"
      />
      <path
        d="M7.24149 9.41382H34.7587C35.1428 9.41382 35.5112 9.5664 35.7828 9.83801C36.0544 10.1096 36.207 10.478 36.207 10.8621C36.207 11.2462 36.0544 11.6146 35.7828 11.8862C35.5112 12.1578 35.1428 12.3104 34.7587 12.3104H7.24149C6.85738 12.3104 6.48901 12.1578 6.2174 11.8862C5.9458 11.6146 5.79321 11.2462 5.79321 10.8621C5.79321 10.478 5.9458 10.1096 6.2174 9.83801C6.48901 9.5664 6.85738 9.41382 7.24149 9.41382Z"
        fill="#161E2E"
      />
    </svg>
  );
}
export function CategoryIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
    >
      <path
        d="M5.89655 15H36.3103C37.0786 15 37.8153 15.3052 38.3585 15.8484C38.9017 16.3916 39.2069 17.1283 39.2069 17.8965V35.2758C39.2069 36.0441 38.9017 36.7808 38.3585 37.324C37.8153 37.8672 37.0786 38.1724 36.3103 38.1724H5.89655C5.12834 38.1724 4.39159 37.8672 3.84838 37.324C3.30517 36.7808 3 36.0441 3 35.2758V17.8965C3 17.1283 3.30517 16.3916 3.84838 15.8484C4.39159 15.3052 5.12834 15 5.89655 15Z"
        fill="#161E2E"
      ></path>
      <path
        d="M26.9943 29.2576V21.0024C26.9938 20.8896 26.9662 20.7785 26.9138 20.6771C26.8613 20.5758 26.7853 20.4869 26.6913 20.417C26.5986 20.3465 26.4903 20.2964 26.3744 20.2704C26.2585 20.2444 26.1378 20.2432 26.0213 20.2669L18.8437 21.7679C18.6665 21.8055 18.5082 21.8989 18.3951 22.0326C18.282 22.1663 18.2208 22.3324 18.2216 22.5033V28.7623C17.6771 28.5205 17.064 28.4512 16.4743 28.565C15.8845 28.6788 15.3498 28.9695 14.9504 29.3935C14.5511 29.8175 14.3086 30.3519 14.2593 30.9165C14.2101 31.4812 14.3567 32.0457 14.6772 32.5252C14.9978 33.0048 15.4749 33.3737 16.0371 33.5765C16.5993 33.7793 17.2162 33.805 17.7952 33.65C18.3743 33.4949 18.8843 33.1673 19.2488 32.7163C19.6132 32.2654 19.8125 31.7154 19.8166 31.1488C19.8249 31.0189 19.8249 30.8886 19.8166 30.7586V23.1037L25.3993 21.9405V27.2614C24.8545 27.0194 24.241 26.9502 23.651 27.0642C23.0609 27.1783 22.526 27.4694 22.1268 27.8939C21.7275 28.3184 21.4854 28.8533 21.4367 29.4183C21.3881 29.9834 21.5356 30.548 21.857 31.0274C22.1784 31.5068 22.6565 31.8752 23.2194 32.0772C23.7823 32.2791 24.3996 32.3038 24.9786 32.1474C25.5577 31.9911 26.0672 31.6622 26.4306 31.2101C26.7941 30.7581 26.9919 30.2072 26.9943 29.6404C27.0019 29.5129 27.0019 29.3851 26.9943 29.2576Z"
        fill="#D4DDE9"
      ></path>
      <path
        d="M10.138 3.62068H31.8621C32.2462 3.62068 32.6146 3.77327 32.8862 4.04487C33.1578 4.31648 33.3104 4.68485 33.3104 5.06896C33.3104 5.45306 33.1578 5.82144 32.8862 6.09304C32.6146 6.36465 32.2462 6.51723 31.8621 6.51723H10.138C9.75387 6.51723 9.38549 6.36465 9.11389 6.09304C8.84228 5.82144 8.6897 5.45306 8.6897 5.06896C8.6897 4.68485 8.84228 4.31648 9.11389 4.04487C9.38549 3.77327 9.75387 3.62068 10.138 3.62068Z"
        fill="#161E2E"
      ></path>
      <path
        d="M7.24149 9.4138H34.7587C35.1428 9.4138 35.5112 9.56639 35.7828 9.83799C36.0544 10.1096 36.207 10.478 36.207 10.8621C36.207 11.2462 36.0544 11.6146 35.7828 11.8862C35.5112 12.1578 35.1428 12.3104 34.7587 12.3104H7.24149C6.85738 12.3104 6.48901 12.1578 6.2174 11.8862C5.9458 11.6146 5.79321 11.2462 5.79321 10.8621C5.79321 10.478 5.9458 10.1096 6.2174 9.83799C6.48901 9.56639 6.85738 9.4138 7.24149 9.4138Z"
        fill="#161E2E"
      ></path>
    </svg>
  );
}
export function DownloadArrowDownIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.3798 17.92C12.5026 17.8724 12.6147 17.801 12.7098 17.71L17.7098 12.71C17.8031 12.6168 17.877 12.5061 17.9275 12.3842C17.9779 12.2624 18.0039 12.1319 18.0039 12C18.0039 11.7337 17.8981 11.4783 17.7098 11.29C17.6166 11.1968 17.5059 11.1228 17.3841 11.0723C17.2622 11.0219 17.1317 10.9959 16.9998 10.9959C16.7335 10.9959 16.4781 11.1017 16.2898 11.29L12.9998 14.59L12.9998 7C12.9998 6.73478 12.8945 6.48043 12.7069 6.29289C12.5194 6.10536 12.265 6 11.9998 6C11.7346 6 11.4802 6.10536 11.2927 6.29289C11.1052 6.48043 10.9998 6.73478 10.9998 7L10.9998 14.59L7.70981 11.29C7.61685 11.1963 7.50625 11.1219 7.38439 11.0711C7.26253 11.0203 7.13183 10.9942 6.99981 10.9942C6.8678 10.9942 6.7371 11.0203 6.61524 11.0711C6.49338 11.1219 6.38278 11.1963 6.28982 11.29C6.19609 11.383 6.12169 11.4936 6.07092 11.6154C6.02015 11.7373 5.99402 11.868 5.99402 12C5.99402 12.132 6.02015 12.2627 6.07092 12.3846C6.12169 12.5064 6.19609 12.617 6.28982 12.71L11.2898 17.71C11.3849 17.801 11.4971 17.8724 11.6198 17.92C11.8633 18.02 12.1364 18.02 12.3798 17.92Z"
        fill="#186CCE"
      />
    </svg>
  );
}
export function DownLoadArrowTrayIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={`${props?.classes}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
      />
    </svg>
  );
}
export function ArrowDownIcon(props) {
  return (
    <svg
      className={`h-[${props.height}] size-4`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export function ArrowUpIcon(props) {
  return (
    <svg
      className={`h-[${props.height}] size-4`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export function ExpandIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="rgb(255 255 255)"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="rgb(255 255 255)"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
      />
    </svg>
  );
}
export function PlusIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={`size-6 ${props.classes}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  );
}
export function MinusIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={`size-3 ${props.classes}`}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
    </svg>
  );
}
export function ArrowKeyLeftIcon(props) {
  return (
    <svg
      className={props.classes}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 10 16"
    >
      <path d="M8.766.566A2 2 0 0 0 6.586 1L1 6.586a2 2 0 0 0 0 2.828L6.586 15A2 2 0 0 0 10 13.586V2.414A2 2 0 0 0 8.766.566Z" />
    </svg>
  );
}
export function ArrowKeyRightIcon(props) {
  return (
    <svg
      className={props.classes}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 10 16"
    >
      <path d="M3.414 1A2 2 0 0 0 0 2.414v11.172A2 2 0 0 0 3.414 15L9 9.414a2 2 0 0 0 0-2.828L3.414 1Z" />
    </svg>
  );
}
export function ArrowKeyUpIcon(props) {
  return (
    <svg
      className={props.classes}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 10"
    >
      <path d="M9.207 1A2 2 0 0 0 6.38 1L.793 6.586A2 2 0 0 0 2.207 10H13.38a2 2 0 0 0 1.414-3.414L9.207 1Z" />
    </svg>
  );
}
export function ArrowKeyDownIcon(props) {
  return (
    <svg
      className={props.classes}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 10"
    >
      <path d="M15.434 1.235A2 2 0 0 0 13.586 0H2.414A2 2 0 0 0 1 3.414L6.586 9a2 2 0 0 0 2.828 0L15 3.414a2 2 0 0 0 .434-2.179Z" />
    </svg>
  );
}
export function RotatePageIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={`${props.classes}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  );
}
export function PrinterIcon(props) {
  return (
    <svg
      className={`${props.classes}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M8 3a2 2 0 0 0-2 2v3h12V5a2 2 0 0 0-2-2H8Zm-3 7a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h1v-4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4h1a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H5Zm4 11a1 1 0 0 1-1-1v-4h8v4a1 1 0 0 1-1 1H9Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export function ThreeBarsIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={`${props.classes}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
}
export function DocumentIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={props.classes}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
      />
    </svg>
  );
}
